var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6399 11.3554C15.2719 11.7145 15.0617 12.2314 15.1143 12.7833C15.1931 13.7294 16.0604 14.4215 17.0065 14.4215H18.6709V15.464C18.6709 17.2773 17.1904 18.7578 15.3771 18.7578H5.32024C3.50686 18.7578 2.02637 17.2773 2.02637 15.464V9.56829C2.02637 7.75491 3.50686 6.27441 5.32024 6.27441H15.3771C17.1904 6.27441 18.6709 7.75491 18.6709 9.56829V10.8298H16.9014C16.4108 10.8298 15.964 11.0225 15.6399 11.3554Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02637 10.3569V6.35345C2.02637 5.31098 2.66587 4.38235 3.63826 4.01442L10.5939 1.38633C11.6802 0.974593 12.8453 1.78057 12.8453 2.94569V6.27459",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5987 11.7236V13.5283C19.5987 14.0101 19.2133 14.4043 18.7227 14.4218H17.0057C16.0596 14.4218 15.1923 13.7297 15.1135 12.7836C15.0609 12.2317 15.2711 11.7148 15.6391 11.3557C15.9632 11.0228 16.41 10.8301 16.9006 10.8301H18.7227C19.2133 10.8476 19.5987 11.2418 19.5987 11.7236Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 9.99805H12.101",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutwhite);
export default __webpack_public_path__ + "static/media/payoutwhite.ad404b107737eef0682c0cb37fe2f01e.svg";
export { ForwardRef as ReactComponent };